import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import getSiteInvoiceValidation, {
  InvoiceValidationResponse,
} from "../http/getSiteInvoiceValidation";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

interface UseSiteInvoiceValidationParams {
  siteId: string;
  fileGuid: string;
  month: string;
  enabled?: boolean;
}

const useSiteInvoiceValidation = ({
  siteId,
  fileGuid,
  month,
  enabled,
}: UseSiteInvoiceValidationParams) => {
  const { getToken } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);

  const fetchInvoiceValidation: UseQueryResult<
    InvoiceValidationResponse,
    unknown
  > = useQuery(
    ["site", siteId, "invoice_validation", fileGuid, month],
    async () => {
      return getSiteInvoiceValidation(
        await getAuthTokenBlocking(getToken, relogin),
        siteId,
        fileGuid,
        month
      );
    },
    {
      enabled: (enabled ?? true) && !!fileGuid && !!month,
      staleTime: 5 * 60 * 1000,
    }
  );

  return {
    fetchInvoiceValidation,
  };
};

export default useSiteInvoiceValidation;
